import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Textarea, Hint, ToggleField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import { useFieldForm } from '../../hooks/useFieldForm.js';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../components/FormContent.js';
import { InspectorFormProvider } from '../../components/InspectorFormProvider.js';
import { ImageField } from '../../components/Input/ImageField/ImageField.js';

function VideoInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(VideoInspectorContent, {
    value: value,
    onChange: onChange
  }));
}
function VideoInspectorContent(_ref2) {
  var value = _ref2.value;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue;
  var _useFieldForm = useFieldForm(),
    fields = _useFieldForm.fields,
    errors = _useFieldForm.errors,
    register = _useFieldForm.register,
    onInputChange = _useFieldForm.onChange,
    trigger = _useFieldForm.trigger;
  var errorMessage = errors['url'];
  useEffect(function () {
    register('url', {
      defaultValue: value.props.src,
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
          var message, url;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                message = '유효하지 않은 비디오 URL입니다.';
                if (value) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _context.prev = 3;
                url = new URL(value);
                if (!(url.protocol !== 'https:' && url.protocol !== 'http:')) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", message);
              case 7:
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                return _context.abrupt("return", message);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 9]]);
        }));
        function validate(_x) {
          return _validate.apply(this, arguments);
        }
        return validate;
      }()
    });
  }, []);
  return jsx(React__default.Fragment, null, jsx(FormContent, {
    header: "\uC378\uB124\uC77C",
    required: true
  }, jsx(ImageField, {
    name: "poster"
  })), jsx(FormContent, {
    header: "\uBE44\uB514\uC624",
    required: true
  }, jsx(Textarea, {
    placeholder: "\uBE44\uB514\uC624 URL \uC785\uB825",
    autoHeight: true,
    value: fields['url'],
    onChange: function onChange(event) {
      var value = event.target.value.replace(/\s/g, '');
      onInputChange('url', value);
    },
    onBlur: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return trigger('url');
          case 2:
            if (_context2.sent) {
              _context2.next = 4;
              break;
            }
            setValue('src', fields['url']);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))
  }), errorMessage && jsx(Hint, {
    className: "hint",
    error: true
  }, errorMessage)), jsx(FormContent, {
    header: "\uBC18\uBCF5\uC7AC\uC0DD"
  }, jsx(ToggleField, {
    name: "loop"
  })), jsx(FormContent, {
    header: "\uC74C\uC18C\uAC70"
  }, jsx(ToggleField, {
    name: "muted"
  })), jsx(FormContent, {
    header: "\uC790\uB3D9\uC7AC\uC0DD"
  }, jsx(ToggleField, {
    name: "autoplay"
  })));
}

export { VideoInspector };
//# sourceMappingURL=Video.Inspector.js.map
